export default __webpack_public_path__ + "static/media/0000..0004.b84eec11.png";